/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskCustomRulesDelete } from "../funcs/riskCustomRulesDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteCustomDetectionRuleRequest,
  DeleteCustomDetectionRuleSecurity,
} from "../models/operations/deletecustomdetectionrule.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskDeleteCustomDetectionRuleMutationVariables = {
  request: DeleteCustomDetectionRuleRequest;
  security?: DeleteCustomDetectionRuleSecurity | undefined;
  options?: RequestOptions;
};

export type RiskDeleteCustomDetectionRuleMutationData = void;

export type RiskDeleteCustomDetectionRuleMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteCustomDetectionRule risk
 *
 * @remarks
 * Delete a custom detection rule.
 */
export function useRiskDeleteCustomDetectionRuleMutation(
  options?: MutationHookOptions<
    RiskDeleteCustomDetectionRuleMutationData,
    RiskDeleteCustomDetectionRuleMutationError,
    RiskDeleteCustomDetectionRuleMutationVariables
  >,
): UseMutationResult<
  RiskDeleteCustomDetectionRuleMutationData,
  RiskDeleteCustomDetectionRuleMutationError,
  RiskDeleteCustomDetectionRuleMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskDeleteCustomDetectionRuleMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskDeleteCustomDetectionRule(): MutationKey {
  return ["@gram/client", "customRules", "delete"];
}

export function buildRiskDeleteCustomDetectionRuleMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskDeleteCustomDetectionRuleMutationVariables,
  ) => Promise<RiskDeleteCustomDetectionRuleMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskDeleteCustomDetectionRule(),
    mutationFn: function riskDeleteCustomDetectionRuleMutationFn({
      request,
      security,
      options,
    }): Promise<RiskDeleteCustomDetectionRuleMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskCustomRulesDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
